import { render, staticRenderFns } from "./MenuEnvelope.vue?vue&type=template&id=3bfc9708&scoped=true"
import script from "./MenuEnvelope.vue?vue&type=script&lang=js"
export * from "./MenuEnvelope.vue?vue&type=script&lang=js"
import style0 from "./MenuEnvelope.vue?vue&type=style&index=0&id=3bfc9708&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfc9708",
  null
  
)

export default component.exports